export const HEATMAP_COLORS: string[] = [
  "#F3F4F6",
  "#D9F99D",
  "#BEF264",
  "#A3C93A",
  "#84A82E",
  "#5F7A1F",
]

export const TASK_COMPLETED_COLORS = {
  withinSla: "#A3C93A",
  breached: "#EF4444",
  pending: "#F59E0B",
} as const

export const MONTHLY_SERIES_COLORS = {
  completed: "#A3C93A",
  closed: "#64748B",
} as const

export const INTENT_TOP_N = 6

export const INTENT_PALETTE: string[] = [
  "#EF4444",
  "#F59E0B",
  "#3B82F6",
  "#8B5CF6",
  "#A3C93A",
  "#EC4899",
  "#94A3B8",
]

export const TIME_SLOTS: string[] = [
  "07:00 - 10:00",
  "10:00 - 13:00",
  "13:00 - 16:00",
  "16:00 - 19:00",
  "19:00 - 22:00",
  "22:00 - 01:00",
  "01:00 - 04:00",
  "04:00 - 07:00",
]

export const DAYS: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
